<template>
  <div>
    <b-table small outlined :items="resultats_challenge" :fields="fields_challenge" sort-by="classement"
      responsive id="table_equipe" thead-class="head_equipes">
      <!-- TEMPLATE ROW CLASSEMENT -->
      <template slot="classement" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0; margin-left: 10px">Clt : {{ data.item.classement }}</p>
      </template>
      <template slot="classement_sexe" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0; margin-left: 10px">Clt sexe : {{ data.item.classement_sexe }}{{
          data.item.sexe }}</p>
      </template>
      <!-- TEMPLATE ROW NOM -->
      <template slot="nom" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">{{ data.item.nom }} {{ data.item.prenom }}</p>
      </template>
      <!-- TEMPLATE ROW TEMPS -->
      <template slot="temps" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Temps : {{ data.item.temps }}</p>
      </template>
      <!-- TEMPLATE ROW MOYENNE -->
      <template slot="moy" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Moyenne : {{ data.item.moy }}km/h</p>
      </template>
      <template #row-details="row">
        <b-card class="inner_equipe_classement">
          <b-table small outlined :items="row.item.coureurs" :fields="fields" @row-clicked="openModal" responsive
            tbody-tr-class="row_coureur_equipe" class="table_coureur_equipe">
            <!-- TEMPLATE ROW NATION -->
            <template slot="Nat" slot-scope="data">
              <img :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'" />
            </template>

            <!-- TEMPLATE ROW AVEC COULEURS -->
            <template v-for="(colored_field, index) in colored_fields" :slot="colored_field" slot-scope="data">
              <span v-if="data.item.sexe === 'F'" style="color: #800080; font-weight: bold" :key="index">{{
                data.item[colored_field] }} </span>
              <span v-if="data.item.sexe === 'M'" style="color: #000080; font-weight: bold" :key="index">{{
                data.item[colored_field] }} </span>
              <span v-if="data.item.sexe === 'X'" style="color: #215b0c; font-weight: bold" :key="index">{{
                data.item[colored_field] }} </span>
            </template>

            <!-- TEMPLATE ROW INFOS -->
            <template slot="Plus" slot-scope="data">
              <b-button size="sm" @click="openModal(data.item, 0)" class="btn-informations">
                <v-icon name="info" style="font-size: 10px" />
              </b-button>
              <b-button size="sm" class="diploma-dl-btn" @click="downloadDiploma(data.item)" v-if="diplome != 0">
                <img src="https://sportips.fr/plateformeResultats/assets/school.svg" class="diploma-icon"
                  style="height: 10px; fill: white" />
              </b-button>
            </template>
            <!-- TEMPLATE ROW TEMPS -->
            <template slot="Temps" slot-scope="data">
              <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>

    <b-modal v-model="show_modal" ref="modal_coureur" size="xl" :title="'Sportips - ' + nom_epreuve" hide-footer>
      <ModalCoureur :coureur="selectedCoureur" :diplome="diplome" :nom_epreuve="nom_epreuve"></ModalCoureur>
    </b-modal>
  </div>
</template>

<script>
import ModalCoureur from "@/component/Epreuve/ModalCoureur";
export default {
  components: { ModalCoureur },

  data() {
    return {
      list_clt_sexe: { X: 1, F: 1, M: 1 },
      selectedCoureur: {},
      show_modal: false,
      resultats_challenge: [],
      fields_challenge: [
        { key: "classement", label: "Clt", sortable: false, tdClass: "" },
        {
          key: "classement_sexe",
          label: "Clt sexe",
          sortable: false,
          tdClass: "",
        },
        { key: "nom", label: "Nom", sortable: false, tdClass: "" },

        { key: "temps", label: "Temps", sortable: false, tdClass: "" },
        { key: "Club", label: "Club", sortable: false, tdClass: "" },
      ],
    };
  },
  watch: {
    resultats() {
      this.buildResultatsChallenge();
    },
  },
  computed: {
    resultats() {
      return this.$store.getters['event/listResultatsFiltered'];
    },
    fields() {
      return this.$store.getters['event/fieldsForChallengeCoureursItems'];
    },
    colored_fields() {
      return this.$store.state.event.data.colored_fields;
    },
    diplome() {
      return this.$store.state.event.data.diplome;
    },
    nom_epreuve() {
      return this.$store.state.event.data.nom_epreuve;
    },
  },
  methods: {
    openModal(data, index) {
      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = this.getNbCoureurInCat();
      this.selectedCoureur.nb_coureur_in_sexe = this.getNbCoureurInSexe();
      this.show_modal = true;
      /* this.$refs["modal_coureur"].show(); */
    },

    getNbCoureurInCat() {
      var c = this.resultats.filter((item) => item.categorie.includes(this.selectedCoureur.categorie) && item.sexe.includes(this.selectedCoureur.sexe));
      return c.length;
    },
    getNbCoureurInSexe() {
      var c = this.resultats.filter((item) => item.sexe.includes(this.selectedCoureur.sexe));
      return c.length;
    },
    downloadDiploma(data) {
      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = this.getNbCoureurInCat();
      this.selectedCoureur.nb_coureur_in_sexe = this.getNbCoureurInSexe();
      if (this.diplome != 0) {
        let routeData = this.$router.resolve({
          name: "GetDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "GetGDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    buildResultatsChallenge() {
      let resultats = this.resultats;
      this.resultats_challenge = [];
      for (var i = 0; i < resultats.length; i++) {
        var found = false;
        for (var j = 0; j < this.resultats_challenge.length; j++) {
          if (this.resultats_challenge[j].nom === resultats[i].nom && this.resultats_challenge[j].prenom === resultats[i].prenom) {
            this.resultats_challenge[j].coureurs.push(resultats[i]);
            found = true;
            break;
          }
        }
        if (!found) {
          this.addCoureur(resultats[i]);
        }
      }
      this.formatResultatsChallenge();
      this.resultats_challenge.sort(this.compareByCoureurTime);
      this.setClassementEquipe();
      this.$emit("updateResultatsChallenge", this.resultats_challenge);
    },
    addCoureur(coureur) {
      /* var coureur_sexe = "Hommes";
      if (coureur.sexe === "F") {
        coureur_sexe = "Femmes";
      }
      if (coureur.sexe === "X") {
        coureur_sexe = "Mixtes";
      } */
      if (coureur)
        var courseCoureur = {
          classement: 0,
          classement_sexe: 0,
          sexe: coureur.sexe,
          nom: coureur.nom,
          prenom: coureur.prenom,
          Club: coureur.Club,
          temps: "01:00:00",
          moy: "5",
          coureurs: [coureur],
          _showDetails: true,
        };

      this.resultats_challenge.push(courseCoureur);
    },

    formatResultatsChallenge() {
      for (var i = 0; i < this.resultats_challenge.length; i++) {
        var sec = 0;
        for (var j = 0; j < this.resultats_challenge[i].coureurs.length; j++) {
          var coureur = this.resultats_challenge[i].coureurs[j];
          var split_time = coureur.temps.split(":");
          var time_in_sec = parseInt(split_time[0]) * 3600 + parseInt(split_time[1]) * 60 + parseInt(split_time[2]);
          sec += time_in_sec;
        }

        this.resultats_challenge[i].temps = this.secondsToTime(sec);
      }
    },
    secondsToTime(secs) {
      secs = Math.round(secs);
      var hours = Math.floor(secs / (60 * 60));
      if (hours < 10) {
        hours = "0" + hours;
      }

      var divisor_for_minutes = secs % (60 * 60);
      var minutes = Math.floor(divisor_for_minutes / 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      var divisor_for_seconds = divisor_for_minutes % 60;
      var seconds = Math.ceil(divisor_for_seconds);
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    },

    compareByCoureurTime(a, b) {
      let tempsA = a.temps.split(":");
      let tempsB = b.temps.split(":");

      if (a.coureurs.length < b.coureurs.length) {
        return 1;
      }
      if (b.coureurs.length < a.coureurs.length) {
        return -1;
      }

      if (parseInt(tempsA[0]) * 3600 + parseInt(tempsA[1]) * 60 + parseInt(tempsA[2]) < parseInt(tempsB[0]) * 3600 + parseInt(tempsB[1]) * 60 + parseInt(tempsB[2])) {
        return -1;
      }
      if (parseInt(tempsA[0]) * 3600 + parseInt(tempsA[1]) * 60 + parseInt(tempsA[2]) > parseInt(tempsB[0]) * 3600 + parseInt(tempsB[1]) * 60 + parseInt(tempsB[2])) {
        return 1;
      }
      return 0;
    },
    setClassementEquipe() {
      this.list_clt_sexe = { X: 1, F: 1, M: 1 };
      for (var i = 0; i < this.resultats_challenge.length; i++) {
        this.resultats_challenge[i].classement = i + 1;
        (this.resultats_challenge[i].classement_sexe = this.list_clt_sexe[this.resultats_challenge[i].sexe]), this.list_clt_sexe[this.resultats_challenge[i].sexe]++;
      }
    },
  },
  created() {

    this.buildResultatsChallenge();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/component/Epreuve/TableauResultatsChallenge.vue